module.exports = __webpack_public_path__ + "assets/dialog_warning_icon.e972898c.svg";